import { render, staticRenderFns } from "./dhis2-diagnostics.html?vue&type=template&id=792ccfae&scoped=true&external"
import script from "./dhis2-diagnostics.js?vue&type=script&lang=js&external"
export * from "./dhis2-diagnostics.js?vue&type=script&lang=js&external"
import style0 from "./dhis2-diagnostics.scss?vue&type=style&index=0&id=792ccfae&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ccfae",
  null
  
)

export default component.exports